import React, { useEffect, useState } from "react";
import {
  Badge,
  Box,
  Button,
  Card,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";

import { enqueueSnackbar } from "notistack";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import useAxiosInterceptor from "../../components/layout/AxiosInstance";
import { useDispatch, useSelector } from "react-redux";
import {
  ShowForms,
  ShowParticularForms,
  ViewUser,
  viewHierarchicalFormall,
} from "../../Service/Apis";
import { setFields } from "../../store/Personslice";
import {
  setFormTeamId,
  setId,
  setManager,
  setRole,
} from "../../store/FormSlice";
import { setSelectedRole } from "../../store/AuthSlice";
import { setIsLoading } from "../../store/LoadingSlice";
// import Navbar from "../../components/Page Component/Navbar";
import Footer from "../../components/Page Component/Footer";
import Skeletons from "../../components/Skeleton/Skeletons";
import HRDashboard from "./HRDashboard";
import ManagerDashboaard from "./ManagerDashboaard";
import AdminDashboard from "./AdminDashboard";
import NothingToDisplayImage from "../../asset/NothingToDisplayImage.png";
import HrReviewForm from "./HrReviewForm";
import EmployeePreviousResponses from "../Form View/EmployeePreviousResponses";
import { setRoles } from "../../store/AuthSlice";
import {
  FetchDataFailureAction,
  FetchDataSuccessAction,
  fetchData,
} from "../../store/actions";
import { RootState } from "../../store/Store";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { CustomTabPanel, a11yProps } from "../../components/TabPanel/TabPanel";
import ThreeSixtyEmployeeDashboard from "./ThreeSixtyForm/ThreeSixtyEmployeeDashboard";
import {
  ToastVariant,
  useCustomToast,
} from "../../components/Methods/SnackBar";
import FeedBackFormDashboard from "./FeedBackForm/FeedBackFormDashboard";
import NothingToDisplayComponent from "../../components/Data/NothingToShowComponent";
// import SideNav from "../../components/Page Component/SideNav";
import SidebarDemo from "../../components/Page Component/SidebarDemo";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../components/Data/NoRowsOverlayComponent"; // or your NoData component
import HistoricalAppraisalChart from "../ProjectRatings/HistoricAppraisalChart";

interface FormType {
  project_name: string;
  team_id: string;
  manager: string; 
  forms: SingleForm[];
}

interface SingleForm {
  form_id: string;
  form_team_id: string;
  form_name: string;
  employee_deadline: string;
  final_submit_done: boolean;
}

const Dashboard = () => {
  const [form, setForm] = useState<FormType[]>([]);

  const [value, setValue] = React.useState(0);
  const [formCount, setFormCount] = useState<number | null>(null);
  const [mainTab, setMainTab] = useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const newToken =
    useSelector((state: any) => state.auth.token) ||
    localStorage.getItem("token");
  const isLoading = useSelector((state: any) => state.loading.isLoading);
  const filledForms = useSelector((state: any) => state.form.filledFormId);

  const axiosInstance = useAxiosInterceptor();
  const emailId = localStorage.getItem("email");

  const dispatch2: ThunkDispatch<
    RootState,
    null,
    FetchDataSuccessAction | FetchDataFailureAction
  > = useDispatch();

  const showToast = useCustomToast();
  const handleShowToast = (
    message: string,
    variant: ToastVariant,
    isCloseable: boolean
  ) => {
    showToast(message, variant, isCloseable);
  };
  const selectedRole = useSelector((state: any) => state.auth.selectedRole);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // Prepare rows and columns
const rows = form.flatMap((team, teamIdx) =>
  team.forms.map((formItem, idx) => ({
    id: formItem.form_id, // DataGrid needs a unique id
    sr_no: idx + 1,
    form_name: formItem.form_name,
    project_name: team.project_name,
    manager: team.manager,
    employee_deadline: formItem.employee_deadline,
    final_submit_done: formItem.final_submit_done,
    form_team_id: formItem.form_team_id,
  }))
);
// Add this at the top of your component:
const [tabIndex, setTabIndex] = useState(0);

const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
  setTabIndex(newValue);
};

const columns: GridColDef[] = [
  { field: "sr_no", headerName: "Sr No.", width: 100, align: "center", headerAlign: "center" },
  { field: "form_name", headerName: "Form Name", width: 200, align: "center", headerAlign: "center" },
  { field: "project_name", headerName: "Team Name", width: 200, align: "center", headerAlign: "center" },
  { field: "manager", headerName: "Manager Name", width: 200, align: "center", headerAlign: "center" },
  { field: "employee_deadline", headerName: "Deadline", width: 150, align: "center", headerAlign: "center" },
  {
    field: "actions",
    headerName: "Actions",
    width: 180,
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) =>
      !params.row.final_submit_done ? (
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            handleSubmit(
              params.row.id,
              params.row.form_team_id,
              params.row.manager
            );
            localStorage.setItem(
              "Role360",
              JSON.stringify({
                isEmployee: false,
                isManager: false,
                isOrganizationLeader: false,
                isPeer: false,
              })
            );
          }}
        >
          Go to Form
        </Button>
      ) : (
        <Button
          variant="contained"
          size="small"
          onClick={e => {
            handleViewResponse(
              e,
              params.row.id,
              params.row.form_team_id
            );
          }}
        >
          View Response
        </Button>
      ),
  },
];


  //Navigate to View Responses Submitted by Employee.
  const handleViewResponse = (e: any, formId: string, formTeamId: string) => {
    e.preventDefault();
    dispatch(setFormTeamId(formTeamId));
    localStorage.setItem("formTeamId", formTeamId);
    dispatch(setId(formId));
    localStorage.setItem("formid", formId);
    navigate("/showresponse");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const authToken = newToken.access ?? token;
        if (authToken) {
          const response = await axiosInstance.get(`${ViewUser}${emailId}`, {
            headers: { Authorization: `Bearer ${authToken}` },
          });
          const person = response.data[0];

          dispatch(setFields(person));
          if (person && person.roles) {
            localStorage.setItem("role", JSON.stringify(person.roles));
            dispatch(setRoles(person?.roles));
            dispatch(setRole(person?.roles[0]));
            if (!selectedRole) {
              dispatch(setSelectedRole(person?.roles[0]));
            }
          }
        }
      } catch (error: any) {
        console.error(error);
      }
    };
    if (emailId && newToken) {
      fetchData();
    }
  }, [emailId, newToken]);

  useEffect(() => {
    dispatch(setIsLoading(true));
    const token = localStorage.getItem("token");
    axiosInstance
      .get(ShowParticularForms, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setForm(res.data);
        setFormCount(
          res.data.reduce(
            (count: any, formItem: any) =>
              count +
              formItem.forms.filter(
                (form: any) => form.final_submit_done === false
              ).length,
            0
          )
        );
        dispatch(setIsLoading(false));
      });
  }, []);

  //To Navigate to Fill Form.
  const handleSubmit = (
    formId: string,
    formTeamId: string,
    manager_name: string
  ) => {
    dispatch(setId(formId));
    localStorage.setItem("formid", formId);
    dispatch(setFormTeamId(formTeamId));
    localStorage.setItem("formTeamId", formTeamId);
    localStorage.setItem(
      "feedbackRole",
      JSON.stringify({
        is_employee_feedback: false,
        is_manager_feedback: false,
      })
    );
    dispatch(setManager(manager_name));
    navigate("/fillForm");
  };

  //Check for role changed and switch between Dashboards.
  const newRole = useSelector((state: any) => state.auth.selectedRole);

  if (newRole === "HR" || newRole === "hr" || newRole === "Hr") {
    return <HRDashboard />;
  }

  if (newRole === "Manager" || newRole === "manager" || newRole === "MANAGER") {
    return <ManagerDashboaard />;
  }

  if (newRole === "ADMIN" || newRole === "Admin" || newRole === "admin") {
    return <AdminDashboard />;
  }

  if (isLoading) {
    return <Skeletons />;
  }

  return (
 <Box sx={{ width: "100%", mt: 10 }}>
  {/* Horizontal Tabs */}
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      width: "100%",
    }}
  >
    <Tabs
      value={tabIndex}
      onChange={(event, newValue) => setTabIndex(newValue)}
      aria-label="Appraisal Tabs"
      textColor="inherit"
      indicatorColor="primary"
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        width: "100%",
        maxWidth: "75rem",
        "& .MuiTabs-flexContainer": {
          justifyContent: "center",
        },
        "& .MuiTab-root": {
          minHeight: 0,
          padding: "10px 20px",
        },
        "& .MuiTabs-indicator": {
          position: "absolute", 
        },
      }}
    >
      <Tab label="Current Appraisals" />
      <Tab label="Previous Responses" />
      <Tab label="Past Appraisals" />
    </Tabs>
  </Box>



    {/* Tab Panels */}
    <Box sx={{ p: 3 }}>
      {/* Current Appraisals Panel */}
      {tabIndex === 0 && (
   <Paper sx={{ m: 2, flexGrow: 1, overflowX: "auto" }}>
  <Box sx={{width: "100%" }}>
    <DataGrid
      autoHeight
      rows={rows}
      columns={columns}
      pageSizeOptions={[5, 10, 15]}
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
      }}
      disableColumnMenu
      disableColumnSelector
      disableDensitySelector
      sx={{
        width: "100%",
        overflowX: "auto",
      }}
      slots={{
        toolbar: GridToolbar,
        noRowsOverlay: CustomNoRowsOverlay,
        noResultsOverlay: CustomNoRowsOverlay,
      }}
      slotProps={{
        toolbar: {
          csvOptions: { disableToolbarButton: true },
          showQuickFilter: true,
          printOptions: { disableToolbarButton: true },
          style: { margin: "0.5rem" },
        },
      }}
    />
  </Box>
</Paper>

      )}
{/* Employee Previous Responses Panel */}
      
{tabIndex === 1 && (
  <Paper sx={{ m: 2, width: "100%", p: 4 }}>
    <EmployeePreviousResponses />
  </Paper>
)}
      {/* Past Appraisals Panel */}
      
       {tabIndex === 2 && (
  <Paper sx={{ m: 2, width: "100%", p: 4 }}>
    <HistoricalAppraisalChart />
  </Paper>
)}
    </Box>
  </Box>
);
};

export default Dashboard;